import React, { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import { showToast } from 'store/toastSlice';
import styles from './alert.module.scss';

interface AlertProps {
  message?: string | null;
  type?: 'success' | 'error' | 'info';
  className?: string; // Allow custom overrides
  onClose?: () => void;
  variant?: 'local' | 'toast';
}

export const Alert: React.FC<AlertProps> = ({
  message,
  type = 'info',
  className = '',
  onClose,
  variant = 'toast',
}) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (variant === 'toast' && message) {
      dispatch(
        showToast({
          text: message,
          type,
        }),
      );
      if (onClose) {
        onClose();
      }
    }
  }, [message, type, dispatch, onClose, variant]);

  if (variant === 'toast') {
    return null;
  }

  if (!message) return null;

  return (
    <div className={`${styles.alert} ${styles[type]} ${className}`}>
      <span className={styles.message}>{message}</span>
      {onClose && (
        <button className={styles.closeBtn} onClick={onClose} aria-label="Close alert">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="16"
            height="16"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      )}
    </div>
  );
};
